import { PageHero } from "@/components/PageHero";
import { Contact } from "@/components/Contact";
import { FAQ } from "@/components/FAQ";

export default function ContactUs() {
  return (
    <>
      <PageHero
        eyebrow="Contact · 04"
        title="Start your"
        italic="next project."
        subtitle="Send us a parcel APN, a draft specific plan, or just a description of the site. We'll come back with an honest read on the path forward — typically within one business day."
        image="https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea"
      />

      <Contact />
      <FAQ />
    </>
  );
}
